import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
    standalone: true,
    name: 'performanceAanvangTijd'
})
export class PerformanceAanvangTijdPipe implements PipeTransform {
    transform(value: string): string {

        if (!value) {
            return null;
        }

        const datePipe = new DatePipe('nl-NL');
        return datePipe.transform(
            value,
            'HH:mm',
            'CEST',
            'nl-NL'
        );
    }
}
